import * as d3 from "d3";
import * as React from "react";
const spinData = {
    class: "running",
    min: 0,
    max: 100,
    value: 25,
};
class RadialProgress extends React.Component {
    mArcGen;
    mRestArcGen;
    mWidthPerArc;
    constructor(props) {
        super(props);
        this.updateArcGen(props);
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        this.updateArcGen(newProps);
    }
    render() {
        const { className, data, offset, style, totalRadius, spin } = this.props;
        const sideLength = (totalRadius + (offset || 0)) * 2;
        const classNames = ["radial", className];
        let progressData = [...data];
        if (spin && progressData.length == 0) {
            // The normal progress has higher priority than the spin
            classNames.push("radial--spin");
            progressData.push(spinData);
        }
        return (React.createElement("svg", { className: classNames.join(" "), viewBox: `0 0 ${sideLength} ${sideLength}`, style: style }, progressData.map(this.renderArc)));
    }
    perc = (bar) => bar.value / (bar.max - bar.min);
    renderArc = (bar, idx, arr) => {
        const { offset, totalRadius } = this.props;
        return (React.createElement("g", { key: idx, transform: `translate(${totalRadius + (offset || 0)}, ${totalRadius + (offset || 0)})` },
            React.createElement("path", { className: `radial-progress radial-progress-${bar.class}`, d: this.mArcGen(bar, idx, arr.length) }),
            React.createElement("path", { className: "radial-rest", d: this.mRestArcGen(bar, idx, arr.length) })));
    };
    updateArcGen(props) {
        const { data, maxWidth, totalRadius } = props;
        const length = Math.max(data.length + 1, 2);
        this.mWidthPerArc = totalRadius / length;
        if (maxWidth !== undefined) {
            this.mWidthPerArc = Math.min(this.mWidthPerArc, maxWidth);
        }
        const offset = this.props.offset ?? 0;
        const gap = this.props.gap ?? 1;
        const innerGap = this.props.innerGap ?? 0;
        const restOverlap = this.props.restOverlap ?? true;
        const inner = (isRest, idx) => {
            let res = offset + innerGap + this.mWidthPerArc * (idx + 1);
            if (isRest && restOverlap) {
                res += (this.mWidthPerArc - gap) / 4;
            }
            return res;
        };
        const outer = (isRest, idx) => {
            let res = offset + this.mWidthPerArc * (idx + 2);
            if (isRest && restOverlap) {
                res -= gap - (this.mWidthPerArc - gap) / 4;
            }
            return res;
        };
        this.mArcGen = d3
            .arc()
            .startAngle(0)
            .endAngle((item) => this.perc(item) * 2 * Math.PI)
            .cornerRadius(4)
            .innerRadius((item, idx, count) => inner(false, idx))
            .outerRadius((item, idx, count) => outer(false, idx));
        this.mRestArcGen = d3
            .arc()
            .startAngle((item) => this.perc(item) * 2 * Math.PI)
            .endAngle(2 * Math.PI)
            .innerRadius((item, idx, count) => inner(true, idx))
            .outerRadius((item, idx, count) => outer(true, idx));
    }
}
export default RadialProgress;
